var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"autocomplete buttons"},_vm._l((_vm.suggestions),function(suggestion){return _c('li',{key:suggestion,staticClass:"button is-small autocomplete--candidate",class:{
      'autocomplete--candidate__latest-selected':
        suggestion === _vm.latestSelectedCandidate,
    },on:{"click":function($event){return _vm.click(suggestion)}}},[_vm._v("\n    "+_vm._s(suggestion)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }